import Link from '@/components/Link';
import type { WordpressTaxonomy } from '@gik/core/models/wordpress/WordpressTaxonomy';
import routes from '@gik/core/routes';
import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Grid } from '@gik/ui/Grid';
import React from 'react';
import RecipientTile from './RecipientTile';

export type RecipientsGridProps = {
  items: WordpressTaxonomy[];
  cols?: number;
  perPage?: number;
  skeleton?: boolean;
  skeletonItems?: number;
  titleInsideBox?: boolean;
} & UIComponent;

function RecipientsGridComp({ items, className }: RecipientsGridProps): React.ReactElement {
  const bem = useBemCN('recipients-grid');

  const taxonomyType = 'recipient';

  function getLinkUrl(item: WordpressTaxonomy) {
    return `${routes.give}/by/${taxonomyType}/${item.slug}`;
  }

  return (
    <Grid cols={4} {...bem(null, null, className)}>
      {items?.map((item, index) => {
        return (
          <Link key={index} href={getLinkUrl(item)} scroll shallow {...bem('item')}>
            <RecipientTile title={item.name} imageUrl={item.acf.tax_thumb_image} />
          </Link>
        );
      })}
    </Grid>
  );
}

export const RecipientsGrid = withComponentErrorBoundary(RecipientsGridComp);

export const RecipientsGridSkeleton = ({
  skeletonItems = 8,
  cols = 4,
}: Partial<RecipientsGridProps>): React.ReactElement => {
  const bem = useBemCN(`recipients-grid`);
  return (
    <Grid cols={cols} {...bem(null, ['skeleton'])}>
      {Array.from(Array(skeletonItems).keys()).map(index => {
        return <RecipientTile key={index} {...bem('item')} />;
      })}
    </Grid>
  );
};
